import React from "react";
import "./style.css";
import LeftSide from "./components/LeftSide";

const SecondStep = () => {
  return (
    <div className="container-fluid dim-bg main-quote-page">
      <div className="row">
        <div className="col-lg-12">
          <LeftSide />
        </div>
      </div>
    </div>
  );
};

export default SecondStep;